import { render, staticRenderFns } from "./BackHomeButton.vue?vue&type=template&id=26b3fc4c&scoped=true&"
import script from "./BackHomeButton.vue?vue&type=script&lang=ts&"
export * from "./BackHomeButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackHomeButton.vue?vue&type=style&index=0&id=26b3fc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3fc4c",
  null
  
)

export default component.exports